/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var ApPageContentController = /** @class */ (function () {
            function ApPageContentController($element, $scope, $timeout, $window, applicationApiService, locationService) {
                var _this = this;
                this.$element = $element;
                this.$scope = $scope;
                this.$timeout = $timeout;
                this.$window = $window;
                this.applicationApiService = applicationApiService;
                this.locationService = locationService;
                this.title = ap.Constants.routes.reporting.label;
                $scope.$on(ap.Constants.eventNames.angular.routeChangeSuccess, function (event, route) { return _this.routeChanged(route); });
                jQuery(window).resize(function () { _this.adjustHeight(); });
                this.adjustHeight();
            }
            ApPageContentController.prototype.adjustHeight = function () {
                var _this = this;
                this.$timeout(function () {
                    var windowHeight = $(_this.$window).outerHeight(true);
                    var parent = _this.$element.parent();
                    var whiteSurround = _this.$element.find('.white-surround');
                    var graySurround = _this.$element.find('.gray-surround');
                    var header = parent.find('.ap-page-header');
                    var subHeader = _this.$element.find('.sub-page-header');
                    var panel = _this.$element.find('.panel');
                    var headerHeight = header.length ? header.outerHeight(true) : 0;
                    var grayMinusWhite = graySurround.outerHeight(true) - whiteSurround.outerHeight(true);
                    var padding = Math.ceil(grayMinusWhite / 2.0);
                    var height = windowHeight - (headerHeight + grayMinusWhite + padding);
                    var subHeaderHeight = subHeader.length ? subHeader.outerHeight(true) : 0;
                    var organizationListHeight = height - subHeaderHeight;
                    var workingHeight = Math.max(height, 300) - 50; //manually adjusting -50 to make up for lack of footer
                    var workingOrganizationListHeight = Math.max(organizationListHeight, 246);
                    whiteSurround.css('height', workingHeight + "px");
                    panel.css('height', workingOrganizationListHeight + "px");
                });
            };
            ApPageContentController.prototype.routeChanged = function (route) {
                this.title = route.label;
            };
            ApPageContentController.$inject = [
                '$element',
                '$scope',
                '$timeout',
                '$window',
                'applicationApiService',
                'locationService'
            ];
            return ApPageContentController;
        }());
        Directives.ApPageContentController = ApPageContentController;
        angular
            .module('app.Directives')
            .controller('ApPageContentController', ApPageContentController);
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
